import styled from '@emotion/styled';

export const WithdrawMessageModalContainer = styled.div`
  width: 100%;
  min-width: 600px;
  max-width: 600px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 600px;
  max-width: 600px;
  margin-top: 50px;
`;

export const ModalFooter = styled.div<{
  isColumnButtons?: boolean;
  isLoading?: boolean;
}>`
    margin-top: 32px;
    display: flex;
    justify-content: ${({ isLoading }) =>
      isLoading ? 'center' : 'space-between'};
    width: 100%;
    flex-direction: ${({ isColumnButtons }) =>
      isColumnButtons ? 'column-reverse' : 'row'};
`;
